import { CompanyClassificationType } from '../constants-types';
import { CompanyCounts } from './CompanyCounts.model';

export class Company {
    readonly id: string;
    readonly name: string;
    readonly shortPublicId: string;
    readonly isDefault: boolean;
    readonly isRetired: boolean;
    readonly hasCognitiveAccess: boolean;
    readonly isTrialAccount: boolean;
    readonly isDeleted: boolean;
    readonly languageLocale: string;
    readonly msTimeZoneIdentifier: string;
    readonly isEnterprise: boolean;
    readonly allowMultipleOILinks: boolean;
    readonly maxNumberOfOILinks: number;
    readonly companyCounts?: CompanyCounts;
    readonly companyClassificationType: CompanyClassificationType =
        CompanyClassificationType.Unknown;

    constructor(obj?: Partial<Company>) {
        Object.assign(this, obj);
    }
}
